import React from "react";
import CardBox from "../shared/card-box/CardBox";
import LeitnerBoxInformationState, { LeitnerBoxInformationProps } from "./LeitnerBoxInformation.models";
import addWord from '../../assest/images/card-image/addWord.png'
import startReading from '../../assest/images/card-image/startReading.png'
import ProgressBar from "../shared/progress-bar/ProgressBar";
import './LeitnerBoxInformation.scss';
import { NavLink, Navigate } from "react-router-dom";
import LearningBoxService from "../../services/content/LearningBoxService";
import LearningBoxCardService from "../../services/content/LearningBoxCardService";

export default class LeitnerBoxInformation extends React.PureComponent<LeitnerBoxInformationProps, LeitnerBoxInformationState> {
    learningBoxService: LearningBoxService;
    learningBoxCardService: LearningBoxCardService;
    constructor(props: LeitnerBoxInformationProps) {
        super(props);
        this.learningBoxCardService = new LearningBoxCardService();
        this.learningBoxService = new LearningBoxService();
        this.state = { boxId: '' };
    }

    componentDidMount() {
        if (this.props.boxId !== null && this.props.boxId !== undefined) {
            this.setState({ boxId: this.props.boxId });
            this.getInformation();
        }
    }

    componentDidUpdate(prevProps: LeitnerBoxInformationProps) {
        if (prevProps.boxId !== this.props.boxId && this.props.boxId !== null && this.props.boxId !== undefined) {
            this.setState({ boxId: this.props.boxId });
            this.getInformation();
        }
    }

    deleteBox = () => {
        // eslint-disable-next-line no-restricted-globals
        let confirmed = window.confirm('آیا از حذف جعبه لایتنر مطمئن هستید؟');
        if (confirmed)
            this.learningBoxService.delete(this.props.boxId as string).then(() => {
                this.setState({ navigateUrl: '/CustomBoxs' })
            })
    }

    getInformation() {
        let state = this;
        this.learningBoxService.getInformationById(this.props.boxId as string).then(response => {
            state.setState({ leitnerBoxInformationDTO: response });
        });
    }

    render(): React.ReactNode {
        let { leitnerBoxInformationDTO } = this.state;
        return <>
            {this.state.navigateUrl != undefined ? <Navigate to={this.state.navigateUrl} /> : null}

            <div className="dropdown-list leitner-box-information-area" style={{ height: "90vh" }} >
                <div className="col-12 col-md-12 tk-padding-top"
                    style={{
                        paddingRight: 0,
                        paddingLeft: 0
                    }}>
                    <div className="row" style={{
                        margin: "0",
                    }}>
                        <div className="col-md-12 col-12 col-lg-4 p-0 leitner-lines-area text-right">
                            <label className="box-title">آمار فعالیت شما</label>
                            {leitnerBoxInformationDTO?.steps.sort((a, b) => { return a.step - b.step }).map((step, key) => {
                                return <ProgressBar key={key} cardCount={step.cardCount} title={"مرحله" + step.step} value={step.levelPrecent} />
                            })}
                        </div>
                        <div className="col-md-12 col-12 col-lg-4 p-0 leitner-read-information-area text-right mb-2">
                            <label className="box-title max">مطالعه</label>
                            <div className="row">
                                <div className="col-6">
                                    <CardBox imageSource={addWord} title="افزودن کلمات" redirectLink={"/LeitnerBoxAddCard?boxId=" + this.state.boxId} />
                                </div>
                                <div className="col-6">
                                    <CardBox imageSource={startReading} title="شروع مطالعه" redirectLink={"/LeitnerBoxCard?boxId=" + this.state.boxId} />
                                </div>
                            </div>
                        </div>

                        <NavLink to={"/LeitnerBoxBookMarks?boxId=" + this.state.boxId} className="col-md-12 col-12 col-lg-4 p-0" >
                            <div className="book-marked-banner">
                                <label>کلمات نشان شده</label>
                            </div>
                        </NavLink>
                        <NavLink to={"/LeitnerFlashCards?boxId=" + this.state.boxId} className="col-md-12 col-12 col-lg-4 p-0 pt-2" >
                            <div className="book-marked-banner word-list">
                                <label>لیست کلمات لایتنر</label>
                            </div>
                        </NavLink>
                    </div>
                    <div className="pt-2">
                        <button className="btn btn-link text-danger d-flex align-items-center" style={{ width: "100%" }} onClick={() => this.deleteBox()}>
                            <i className="mdi mdi-18px mdi-delete p-1"></i>
                            <span>حذف جعبه لایتنر</span>
                        </button>
                    </div>
                </div >

            </div>
        </>
    }


}